// render the page with tabIndex
const TabPage = ({ tabIndex, pages }) => {
  if (tabIndex < pages.length && tabIndex >= 0) {
    return pages[tabIndex];
  } else {
    return <div>index out of range</div>;
  }
};

export default TabPage;
